import React from "react";
import "./IndustriesSection.css";
import {
  FaBitcoin, FaPiggyBank, FaBroadcastTower, FaBuilding, FaUniversity,
  FaChalkboardTeacher, FaMoneyBillWave, FaShoppingCart, FaStore
} from "react-icons/fa";
import bgImg from "../../assets/img/bg/handshake-bg.jpg";

// Glass cards data (order and labels match the screenshot)
const industries = [
  { label: "FinTech", icon: <FaBitcoin /> },
  { label: "Banking", icon: <FaPiggyBank /> },
  { label: "Telecom", icon: <FaBroadcastTower /> },
  { label: "Real Estate", icon: <FaBuilding /> },
  { label: "Education", icon: <FaChalkboardTeacher /> },
  { label: "Government", icon: <FaUniversity /> },
  { label: "Finance", icon: <FaMoneyBillWave /> },
  { label: "E-Commerce", icon: <FaShoppingCart /> },
  { label: "SMEs", icon: <FaStore /> },
];

const IndustriesSection = () => {
  return (
    <section id="industries-served" className="rs-industries-served">
      {/* Background image + vignette overlay */}
      <div className="rs-industries-bg" style={{ backgroundImage: `url(${bgImg})` }} />

      <div className="container position-relative">
        {/* Title badge */}
        <div className="rs-industries-title text-center">
          <div className="title-badge">
            <span className="pin" />
            <span className="badge-text">INDUSTRIES</span>
          </div>
          <h2 className="served-text">SERVED</h2>
        </div>

        {/* Glass frame */}
        <div className="glass-frame mx-auto">
          <div className="row g-3 g-md-4">
            {industries.slice(0, 3).map((item) => (
              <div key={item.label + "-top"} className="col-12 col-md-4">
                <div className="glass-card d-flex align-items-center">
                  <div className="icon">{item.icon}</div>
                  <div className="label">{item.label}</div>
                </div>
              </div>
            ))}

            {industries.slice(3, 6).map((item) => (
              <div key={item.label + "-mid"} className="col-12 col-md-4">
                <div className="glass-card d-flex align-items-center">
                  <div className="icon">{item.icon}</div>
                  <div className="label">{item.label}</div>
                </div>
              </div>
            ))}

            {industries.slice(6, 9).map((item) => (
              <div key={item.label + "-bottom"} className="col-12 col-md-4">
                <div className="glass-card d-flex align-items-center">
                  <div className="icon">{item.icon}</div>
                  <div className="label">{item.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
